//constants
import {
  BASE_URL,
  numberRegex,
  STRINGS,
  USER_IMAGES,
  USER_ROLES,
} from "../constants";

export const pageNumbers = (selectedPage, count, pagesCutOff) => {
  let pageLabels = [];
  let totalPages = Math.ceil(count / 10);
  let start,
    end,
    ceiling = Math.ceil(pagesCutOff / 2),
    floor = Math.floor(pagesCutOff / 2);

  if (totalPages < pagesCutOff) {
    start = 0;
    end = totalPages;
  } else if (selectedPage >= 1 && selectedPage <= ceiling) {
    start = 0;
    end = pagesCutOff;
  } else if (selectedPage + floor >= totalPages) {
    start = totalPages - pagesCutOff;
    end = totalPages;
  } else {
    start = selectedPage - ceiling;
    end = selectedPage + floor;
  }

  for (let i = start; i < end; i++) {
    pageLabels.push(i + 1);
  }

  return pageLabels;
};

export const validContactNumber = (value) => {
  if (value === "" || /^[\d+-]+$/.test(value)) {
    return true;
  } else {
    return false;
  }
};

export const validPostalCode = (value) => {
  if (value === "" || numberRegex.test(value)) return true;
  return false;
};

export const formatImage = (url) => `${BASE_URL}uploads/profilePics${url}`;

export const matchUserImage = (id) =>
  USER_IMAGES.find((image) => image._id === id)?._image;

export const capitalizeText = (value) =>
  value.charAt(0).toUpperCase() + value.slice(1);

export const permissionsFormatter = (data = []) => {
  let permissions = {};
  data.forEach((d) => {
    let key = getKeyByValue(USER_ROLES, d.role);
    if (!Object.keys(permissions).includes(key)) {
      permissions = {
        ...permissions,
        [key]: [],
      };
    }
    permissions[key].push(d.permission);
  });
  return permissions;
};

const getKeyByValue = (object, value) => {
  for (var prop in object) {
    if (object.hasOwnProperty(prop)) {
      if (object[prop] === value) return prop;
    }
  }
};

export const ageCalculator = (date) => {
  let today = new Date();
  let birthDate = new Date(date);
  let age = today.getFullYear() - birthDate.getFullYear();
  let m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const BMIcalculator = (weight, height) => {
  if (weight && height) {
    return `${(weight / (height * 0.01 * height * 0.01)).toFixed(2)} kg/m²`;
  }
  return "NA";
};

export const sanitizeQuery = (payload) => {
  let query = "";
  const { userId, limit, offset, role, searchString, filterType, date } =
    payload;
  if (userId) query += `userId=${userId}&`;
  if (filterType) query += `filterType=${filterType}&`;
  if (limit) query += `limit=${limit}&`;
  if (offset) query += `offset=${offset}&`;
  if (role) query += `role=${role}&`;
  if (searchString) query += `searchString=${searchString}&`;
  if (date) query += `date=${date}&`;
  return query.slice(0, query.length - 1);
};

export const sanitizAddress = (data) => {
  let address = "";
  const { city, town, country } = data;
  // if (buildingNumber) address += `${buildingNumber},`;
  // if (streetName) address += ` ${streetName}, `;
  if (city) address += ` ${city},`;
  if (town) address += ` ${town},`;
  if (country) address += ` ${country},`;
  else address = STRINGS.EMPTY_DATA;
  return address.slice(0, address.length - 1);
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

export const getDeviceName = (deviceType) => {
  switch (deviceType) {
    case 1:
      return "Spiro Link";
    case 2:
      return "Finger Tip Oxymeter";
    case 3:
      return "Oxy Knight";
    case 4:
      return "Oxy Knight Lite";
    case 5:
      return "ACT(Asthama Control Test)";
    default:
      return "";
  }
};

export const getTestType = (deviceType) => {
  switch (deviceType) {
    case 1:
      return "Spiro Link";
    case 2:
      return "SpO2";
    case 3:
      return "SpO2";
    case 4:
      return "SpO2";
    case 5:
      return "ACT(Asthama Control Test)";
    default:
      return "";
  }
};
